import { Box } from '@breathelife/mui';
import { ReactElement } from 'react';

import { RenderingField } from '@zinnia/form-engine-sdk';

import { BaseFieldProps } from '../FieldGenerator/FieldGenerator';
import { Field } from './Field';
import { QuestionContainer } from './Styles';
import { ReactHtmlParser } from '@breathelife/ui-components';

export type ProSummaryQuestionProps = BaseFieldProps;

export function ProSummaryQuestion(props: ProSummaryQuestionProps): ReactElement | null {
  const { currency, locale, fieldGroup } = props;

  return (
    <QuestionContainer mt={2}>
      {fieldGroup.title && (
        <Box fontSize={14} fontWeight={600}>
          <ReactHtmlParser html={fieldGroup.title} />
        </Box>
      )}
      {fieldGroup.text && (
        <Box fontSize={14} fontWeight={600}>
          <ReactHtmlParser html={fieldGroup.text} />
        </Box>
      )}
      {fieldGroup.fields.map((field: RenderingField) => (
        <Field key={field.id} currency={currency} field={field} locale={locale} />
      ))}
    </QuestionContainer>
  );
}
